import React from 'react'
import { useNavigate } from 'react-router-dom'
import SupplierCard from './SupplierCard'
import SupplierGraph from './SupplierGraph'

const Index = () => {
  const naviagte = useNavigate()

  const toNaviagte = (id: any) => {
    if (id === 1) {
      naviagte('/report')
    } else {
      naviagte('/report/advance-supplier-dashboard')
    }
  }

  return (
    <>
      <div
        id='kt_app_toolbar_container'
        className='app-container container-fluid d-flex flex-stack'
      >
        <div className='card-title col-4 align-items-start flex-row d-flex '>
          <span className='mt-1 text-hover-primary'>
            <i
              className='bi bi-arrow-left'
              style={{ fontSize: '1.75rem' }}
              onClick={() => toNaviagte(1)}
            ></i>
          </span>
          <h1
            className='page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center '
            style={{ marginLeft: '10px', marginTop: '4px' }}
          >
            Supplier Dashboard
          </h1>
        </div>
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <button className='btn btn-sm btn-primary' onClick={() => toNaviagte(2)}>
            Advance Dashboard
          </button>
        </div>
      </div>

      <div className='row g-4 mb-4' style={{ marginTop: '20px' }}>
        <SupplierCard title='Total Supplier' value='5' cardStyle='rgb(59 178 199)' />
        <SupplierCard title='Average Availability' value='91.78%' cardStyle='rgb(255, 157, 38)' />
        <SupplierCard title='Average Defect Rate' value='3.50%' cardStyle='#FC4065' />
      </div>

      <div className='row g-4 mb-4' style={{ marginTop: '20px' }}>
        <div className='col-xl-12 col-lg-12 col-md-12 col-xm-12'>
          <SupplierGraph />
        </div>
      </div>
    </>
  )
}

export default Index
